(ns teamoesterreich.util.markdown
  (:require [clojure.string :as str]
            [reagent-material-ui.components :as mui]
            ["signature_pad" :default SignaturePad]
            [teamoesterreich.util.helper :as h]
            [teamoesterreich.util.sign-pad :as sign]
            [reagent.core :as r]))

(def md
  (try
    (.. (js/markdownit #js{:html    true
                           :breaks  true
                           :linkify true})
        (use js/markdownitMark)
        (use js/markdownitEmoji)
        ;(use js/markdownitFootnote)
        )
    (catch :default _
      #js{:render      str
          :parse       str
          :parseInline str})))

(defn md-component [md-text]
      [:span {:class "md-form-block" :style {:margin "0"}
              :dangerouslySetInnerHTML
              {:__html
               (.render md md-text)
               }}])



(defn md-form [md-text on-sign]
      (let [!form (r/atom {})
            !signed (r/atom false)
            !missing (r/atom {})]
           (fn [md-text]
               (let [on-submit (fn [sign]
                                   (on-sign @!form sign))]
                    [:p {:class "md-form"}
                     (into [:p {:class "md-form-part"}]
                           (for [md-line (str/split-lines md-text)]
                                (cond

                                  (str/starts-with? md-line "F[checkbox]")
                                  (let [name_ (str/trim (subs md-line (count "F[checkbox-required]")))]
                                       [:div
                                        [mui/form-control-label
                                         {:control  (r/as-element [mui/checkbox
                                                                   :disabled @!signed
                                                                   :checked (get @!form name_)
                                                                   :onChange (fn [_ v] (swap! !form assoc name_ v))
                                                                   ])
                                          :disabled @!signed
                                          :label    (r/as-element [md-component (subs md-line (count "F[checkbox]"))])
                                          :style    {:paddingRight "10px"}
                                          }
                                         ]])

                                  (str/starts-with? md-line "F[checkbox-required]")
                                  (let [name_ (str/trim (subs md-line (count "F[checkbox-required]")))
                                        err (not (get @!form name_))]
                                       (when (or (nil? (get @!missing name_)) (not= err (get @!missing name_)))
                                             (swap! !missing assoc name_ err))
                                       [:div
                                        [mui/form-control-label
                                         {:control    (r/as-element [mui/checkbox {:style    {:color "red"}
                                                                                   :disabled @!signed
                                                                                   :checked  (get @!form name_)
                                                                                   :onChange (fn [_ v] (swap! !form assoc name_ v))
                                                                                   }])
                                          :label      (r/as-element [md-component (subs md-line (count "F[checkbox-required]"))])
                                          :style      {:paddingRight "10px"}
                                          :disabled   @!signed
                                          :error      err
                                          :helperText (when err "!Pflichtfeld")
                                          }
                                         ]])

                                  (str/starts-with? md-line "F[textfield]")
                                  (let [name_ (str/trim (subs md-line (count "F[textfield]")))]
                                       [:div
                                        [mui/text-field
                                         {:label     name_
                                          :style     {:marginTop "15px"}
                                          :fullWidth true
                                          :disabled  @!signed
                                          :variant   "outlined"
                                          :value     (get @!form name_)
                                          :onChange  (fn [e] (swap! !form assoc name_ (h/event-value e)))
                                          }
                                         ]])

                                  (str/starts-with? md-line "F[textfield-required]")
                                  (let [name_ (str/trim (subs md-line (count "F[textfield-required]")))
                                        err (str/blank? (str (get @!form name_)))]
                                       (when (or (nil? (get @!missing name_)) (not= err (get @!missing name_)))
                                             (swap! !missing assoc name_ err))
                                       [:div
                                        [mui/text-field
                                         {:label      name_
                                          :style      {:marginTop "15px"}
                                          :fullWidth  true
                                          :disabled   @!signed
                                          :error      err
                                          :helperText (when err "!Pflichtfeld")
                                          :variant    "outlined"
                                          :value      (get @!form name_)
                                          :onChange   (fn [e] (println "changed " name_ ":" @!form) (swap! !form assoc name_ (h/event-value e)))
                                          }
                                         ]])


                                  :else
                                  ;; markdown
                                  [md-component md-line]
                                  )))

                     ;[:h3 "Missing " (pr-str @!missing) "->" (if form-ok? "ok" "nok")]
                     (if (reduce (fn [c [k v]] (and c (not v))) true @!missing)
                       [sign/signature-pad !signed on-submit]
                       [:h3 {:style {:color "darkred"}} "Pflichtfelder fehlen!"])
                     ]))))






